module.exports = __webpack_public_path__ + "img/327697.70b8a98f.png";